import { render } from "./TerminosCondiciones.vue?vue&type=template&id=b1a731d4"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__